import { Component } from '@angular/core';

import { SystemSiteService } from 'app/services/system-site.service';
import { Subscription } from 'rxjs';

interface Partner {
  name: string;
  logo: string;
  website?: string;
}

@Component({
  selector: 'app-block-lab-partners',
  templateUrl: './block-lab-partners.component.html',
  styleUrls: ['./block-lab-partners.component.scss']
})
export class BlockLabPartnersComponent {
  canScrollLeft = false;
  canScrollRight = true;



  labPartnerSubscription: Subscription = null;

  public result_message = ""
  constructor(private systemSiteService: SystemSiteService) { }


  partners: Partner[] = [];

    ngOnInit() {


    this.LoadData();




  }


  LoadData() {
    this.labPartnerSubscription = this.systemSiteService.get_lab_partner().subscribe({
      next: (data) => {
        console.log(data.result_data)
        this.partners = data.result_data;

      },
      error: (error) => { console.log(error) },
    })
  }


  trackByPartner(index: number, partner: Partner): string {
    return partner.name;
  }

  scrollLeft(): void {
    const container = document.querySelector('.partners-grid') as HTMLElement;
    if (container) {
      container.scrollBy({ left: -200, behavior: 'smooth' });
      this.updateScrollButtons();
    }
  }

  scrollRight(): void {
    const container = document.querySelector('.partners-grid') as HTMLElement;
    if (container) {
      container.scrollBy({ left: 200, behavior: 'smooth' });
      this.updateScrollButtons();
    }
  }

  openWebsite(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  private updateScrollButtons(): void {
    setTimeout(() => {
      const container = document.querySelector('.partners-grid') as HTMLElement;
      if (container) {
        this.canScrollLeft = container.scrollLeft > 0;
        this.canScrollRight = container.scrollLeft < (container.scrollWidth - container.clientWidth);
      }
    }, 100);
  }

  ngAfterViewInit(): void {
    // Initialize scroll button states
    this.updateScrollButtons();

    // Add scroll event listener
    const container = document.querySelector('.partners-grid') as HTMLElement;
    if (container) {
      container.addEventListener('scroll', () => this.updateScrollButtons());
    }
  }

    ngOnDestroy(): void {
    if (this.labPartnerSubscription)
      this.labPartnerSubscription.unsubscribe();

  }
}
